import { debounce } from 'lodash-es';
import { isElementInViewport } from './is-element-in-viewport';
function showElements(elements) {
    elements.forEach(element => {
        if (isElementInViewport(element)) {
            element.classList.add('show');
        }
    });
}
export function addSlideUpAnimation(selector) {
    const elements = document.querySelectorAll(selector);
    showElements(elements);
    document.addEventListener('scroll', debounce(() => {
        showElements(elements);
    }, 200));
}
